export function strContains(search: string, searchIn: string): boolean {
	return (
		searchIn.toLowerCase().trim().indexOf(search.toLowerCase().trim()) > -1
	);
}
